import { isNull } from "../../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import AbstractView from "../../../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class DialogSceneView extends AbstractView {

    constructor(target) {
        super(target);
    }

    createAndShowScene(sceneName, assets, animateIn = true) {
        if (isNull(assets[sceneName])) {
            console.error(`[DialogSceneView.createAndShowScene] scene with name '${sceneName}' does not exist.`);
        } else {
            this.showScene(new assets[sceneName](), animateIn);
        }
    }

    showScene(sceneSkin, animateIn = true) {
        if (sceneSkin == null) {
            console.error(`[DialogSceneView.showScene] scene skin does not exist.`);
            return;
        }

        this._target.removeAllChildren();
        this._target.addChild(sceneSkin);
        this._scene = sceneSkin;
        if (this._scene.balloon) {
            this._scene.balloon.visible = false;
        }
        if (animateIn) {
            this.animateIn();
        }
    }

    hideElements() {
        for (let i = 0; i < 29; i++) {
            const elem = this._scene["elem" + i];
            if (!elem) {
                continue;
            }
            elem.visible = false;
        }
    }

    animateIn() {
        //animate elements in, if any
        const delta = DELAY_BETWEEN;
        let delay = DELAY_INITIAL;
        for (let i = 0; i < 29; i++) {
            const elem = this._scene["elem" + i];
            if (!elem) {
                continue;
            }
            elem.visible = false;
            const scale = elem.scaleX;
            elem.scaleX = elem.scaleY = .01 * scale;
            createjs.Tween.get(elem)
                .wait(delay += delta)
                .set({ visible: true })
                .wait(1)
                .to({ scaleX: scale, scaleY: scale }, DURATION_POP_IN, createjs.Ease.backOut);
        }
    }

    /**
     * 
     * @returns DisplayObject Balloon instance or null
     */
    getBalloon() {
        return this._scene.balloon;
    }
}

const DELAY_INITIAL = 100;
const DELAY_BETWEEN = 100;
const DURATION_POP_IN = 300;